import {put, take, takeEvery} from 'redux-saga/effects';
import {api, token} from 'helpers';

export function* exportREQUEST() {
  while (true) {
    try {
      const { values }  = yield take('EXPORTED_FILES_REQUEST');
      yield api('/export/', values);
    } catch (error) {
      yield put({
        type: 'UI_ERROR',
        errorMessage: 'Something went wrong. Please try again later.',
        error,
      });
    }
  }
}

export function* exportRead() {
  while (true) {
    try {
      yield take(['APP_LAUNCH', 'EXPORTED_FILES_READ']);
      const { files } = yield api('/export-info');
      yield put({
        type: 'EXPORTED_FILES',
        files,
      });
    } catch (error) {
      yield put({
        type: 'EXPORT_ERROR',
        error,
      });
    }
  }
}

export function* exportRemove() {
  yield takeEvery('EXPORTED_FILES_REMOVE', function* ({ files = [] }) {
    try {
      for (const file of files) {
        yield api(`/export/${token().token}/delete/${file.name}`, null, { body: undefined, method: 'get' });
      }
    } catch (error) {
      yield put({
        type: 'EXPORT_ERROR',
        error,
      });
    }
  });
}
